
// ROUTES
require('modules/media-upload/routes/media-upload');

// CONTROLLERS
require('modules/media-upload/controllers/media-upload');
require('modules/media-upload/controllers/list');

// SERVICES
require('modules/media-upload/services/media-upload');
require('modules/media-upload/services/list');
require('modules/media-upload/services/edit');
require('modules/media-upload/services/delete');


angular.module('unica_media_upload', [

	'infinite-scroll',
	'angular-confirm',
	'bootstrapLightbox',

	// ROUTES
	'unica_media_upload.media_routes',

	// CONTROLLERS
	'unica_media_upload.media_controllers',

	// SERVICES
	'unica_media_upload.media_services'

]);